module.exports = __webpack_public_path__ + "img/header2.dbfec568.jpeg";